import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as employeeApi from '../../lib/api/employee';

//성과관리
const [LIST_RESULT, LIST_RESULT_SUCCESS, LIST_RESULT_FAILURE] =
  createRequestActionTypes('employee/LIST_RESULT');

export const listResult = createAction(LIST_RESULT, (params) => params);
const listResultSaga = createRequestSaga(
  LIST_RESULT,
  employeeApi.getResumeByEmp,
);

const UNLOAD_RESULT = 'employee/UNLOAD_RESULT';
export const unloadResult = createAction(UNLOAD_RESULT);

//가족정보
const [LIST_NP, LIST_NP_SUCCESS, LIST_NPE_FAILURE] =
  createRequestActionTypes('employee/LIST_NP');

export const listNP = createAction(LIST_NP, (params) => params);
const listNpSaga = createRequestSaga(LIST_NP, employeeApi.getResumeByEmp);

const UNLOAD_NP = 'employee/UNLOAD_NP';
export const unloadNp = createAction(UNLOAD_NP);

export function* employeeHrSaga() {
  yield takeLatest(LIST_RESULT, listResultSaga);
  yield takeLatest(LIST_NP, listNpSaga);
}

const initialState = {
  results: null,
  resultsError: null,
  nps: null,
  npsError: null,
};

const employeeHr = handleActions(
  {
    [LIST_RESULT_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      results: data.list.map((result) => ({
        id: result.infoUuid,
        infoUuid: result.infoUuid,
        usrUuid: result.usrUuid,
        infoTyp: result.infoTyp,
        attrVal1: result.attrVal1,
        attrVal2: result.attrVal2,
        attrVal3: result.attrVal3,
        crtNm: result.crtNm,
        crtDt: result.crtDt,
        cngNm: result.cngNm,
        cngDt: result.cngDt,
      })),
      resultsError: null,
    }),
    [LIST_RESULT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      resultsError: error,
    }),
    [UNLOAD_RESULT]: (state) => ({
      ...state,
      results: null,
      resultsError: null,
    }),
    [LIST_NP_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      nps: data.list.map((np) => ({
        id: np.infoUuid,
        infoUuid: np.infoUuid,
        usrUuid: np.usrUuid,
        infoTyp: np.infoTyp,
        attrVal1: np.attrVal1,
        attrVal2: np.attrVal2,
        attrVal3: np.attrVal3,
        attrVal4: np.attrVal4,
        attrVal5: np.attrVal5,
        crtNm: np.crtNm,
        crtDt: np.crtDt,
        cngNm: np.cngNm,
        cngDt: np.cngDt,
      })),
      npsError: null,
    }),
    [LIST_NPE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      npsError: error,
    }),
    [UNLOAD_NP]: (state) => ({
      ...state,
      nps: null,
      npsError: null,
    }),
  },
  initialState,
);

export default employeeHr;
